import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Table, Button, message, Tooltip } from 'antd';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import { InfoCircleOutlined } from '@ant-design/icons';
import apis from '@/apis/room/index';
import { getCrumb } from '@/components/bread-crumbs/cached-crumbs';
import { env } from '@/env';
import provideActivityLink from '@/components/provide-activity-link';
import { withRouter } from 'react-router-dom';
import './index.less';

const STATUSTYPE = ['', '未开始', '进行中', '已过期', '已下线'];

function Detail(props, ref) {
  const { pageType } = provideActivityLink.useActivityLink();
  const { data, towerId, otherData, planCode, power } = props;
  const { name, status, startTime, createErp, id, itemPoolActivityId } = data;
  const link =
    `activityId=${otherData.id}&pageId=${id}&activityName=${otherData.name}&pageName=${name}&item=${otherData.item}` +
    `&encryptActivityId=${otherData.encryptActivityId}&previewTime=${startTime}&beginDate=${otherData.startTime}` +
    `&endDate=${otherData.endTime}&activityBu=mall&activityType=active&mode=online` +
    (planCode ? `&planCode=${planCode}` : '') +
    (itemPoolActivityId ? `&poolActivityId=${itemPoolActivityId}` : '') +
    `&breadcrumbs=${encodeURIComponent(JSON.stringify(getCrumb({ hasDomain: true })))}`;
  const baseLink = '/materials/babel#/editorDemo?';
  const toLink =
    env.BABEL_DOMAIN +
    '/active/babelTower/index.html#/editorDemo?' +
    link +
    '&' +
    provideActivityLink.themeActivityType.getThemeActivityTypeQuery(pageType);
  const realPageLink =
    env.BABEL_DOMAIN +
    '/active/babelTower/index.html#/editor?' +
    link +
    '&' +
    provideActivityLink.themeActivityType.getThemeActivityTypeQuery(pageType);
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const {
    tower_activity_change,
    tower_activity_create,
    tower_activity_entrance,
    tower_activity_link,
    tower_data_display,
    tower_header_info,
    tower_page_list,
    tower_page_setup,
  } = power ? power : {};

  const pageChange = (current, pageSize) => {
    setPagination({
      ...pagination,
      current: current,
    });
  };

  useImperativeHandle(ref, () => ({
    refresh: () => {
      setPagination({
        ...pagination,
        current: 1,
      });
    },
  }));

  const jumpBabel = (identityId) => () => {
    window.open(
      env.BABEL_DOMAIN +
        '/active/babelTower/index.html#/editor?' +
        (identityId ? `yxIdentityId=${identityId}&` : '') +
        link
    );
  };
  // const jumpPreview = () => {
  //   window.open(toPreviewLink)
  // }

  const labelType = {
    1: '商品',
    2: '广告',
    3: '广告+商品',
  };

  const materialJump = {
    1: '/launch/#/goods-manage?goodsGroupId=',
    2: '/launch/#/adv-manage?advGroupId=',
  };

  const columns = [
    {
      title: '楼层模块',
      key: 'floorName',
      width: '33.3%',
      render: (_, record) => {
        return (
          <div className="venue-activity__info__table__floor">
            <div className="venue-activity__info__table__floorName">{`${record.floorName}-${record.templateName}`}</div>
            {labelType[record.materialType] && (
              <div className="venue-activity__info__table__label">{labelType[record.materialType]}</div>
            )}
          </div>
        );
      },
    },
    {
      title: '已关联素材组(素材组ID)',
      key: 'materialGroup',
      width: '33.3%',
      render: (_, record) => {
        const isEmpty = record.materialGroups.length === 0;
        const hasMore = record.materialGroups.length > 3;
        let arr = record.materialGroups;
        if (hasMore) {
          arr = record.materialGroups.slice(0, 3);
        }
        return isEmpty ? (
          '-'
        ) : (
          <div className="tower__wrapper">
            {arr.map((item, index) => {
              return (
                <div key={index} style={{ marginRight: 5 }}>
                  <Tooltip
                    title={
                      <div className="tower__card-wrapper">
                        <div className="tower__id-wrapper">
                          <div style={{ width: 164 }}>
                            素材组ID：<a style={{ cursor: 'default' }}>{item.materialGroupId}</a>
                          </div>
                          <div className="tower__id__label">{labelType[item.materialGroupType]}</div>
                        </div>
                        <div style={{ marginTop: 8 }}>收取方式：{item.materialGroupSource}</div>
                        <div style={{ marginTop: 2 }}>创建人：{item.createErp}</div>
                      </div>
                    }
                    placement="bottomLeft"
                    color="white"
                  >
                    <a
                      href={materialJump[item.materialGroupType] + item.materialGroupId}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.materialGroupId} <InfoCircleOutlined style={{ color: '#2D64FF' }} />
                    </a>
                  </Tooltip>
                </div>
              );
            })}
            {hasMore && <a onClick={jumpBabel(record.id)}>更多</a>}
          </div>
        );
      },
    },
    {
      title: '操作 (跳转通天塔对应楼层)',
      key: 'action',
      width: '33.3%',
      render: (_, record) => {
        return (
          <Button type="link" onClick={jumpBabel(record.id)}>
            查看详情
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    apis
      .floorList({
        towerId,
        pageId: id,
        platform: 0,
      })
      .then(({ ret, msg, data }) => {
        if (ret === '0') {
          setDataList(
            data.list.map((item, index) => ({
              key: index,
              ...item,
            }))
          );
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [towerId, id]);

  return (
    <>
      <div className="venue-activity__info-title">
        <div className="venue-activity__info-title__detail">
          <div className="venue-activity__info-title__detail__status">
            <div className="venue-activity__info-title__detail__status__circle" style={{ background: 'red' }} />
            {STATUSTYPE[status]}
          </div>
          <div className="venue-activity__info-title__detail__divider" />
          <div className="venue-activity__info-title__detail__startTime">
            开始时间: {enhancedFormateTimeStamp(startTime)}
          </div>
          <div className="venue-activity__info-title__detail__createErp">创建人: {createErp}</div>
        </div>
      </div>
      <Table
        dataSource={dataList}
        columns={columns}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          onChange: pageChange,
          showSizeChanger: false,
        }}
      />
    </>
  );
}

export default withRouter(React.forwardRef(Detail));
